// extracted by mini-css-extract-plugin
export default {"container":"Home_container__ufLbz","content":"Home_content__D3unG"};